export const select2Status = {
    placeholder: "",
    allowClear: true
}